import DataTable from "@/components/admin/DataTable";
import { adminApi } from "@/lib/adminApi";

const columns = [
  { key: "created_at", label: "Reçu le", format: "date" },
  { key: "prenom", label: "Prénom" },
  { key: "email", label: "Email" },
];

export default function LeadsList() {
  return (
    <DataTable
      testId="admin-leads"
      title="Lead magnet — Guide PDF"
      subtitle="Personnes ayant demandé le guide « Comprendre ce qui se répète »."
      fetcher={adminApi.listLeads}
      columns={columns}
    />
  );
}
